module.exports = "/assets/data/63eefd9a27f5cc1adaa382ded6ea046e-SA34.data.json";